// extracted by mini-css-extract-plugin
export default {"rating":"LG-z","numberOfStars":"MG-z","count":"NG-z","barGraphSpacing":"OG-z","barGraph":"PG-z"};